<template>
  <div class="row">
    <div class="col-md-12">
      <card card-body-classes="table-full-width">
        <h4 slot="header" class="card-title">Striped table</h4>
        <el-table :data="data" :key="componentKey">
          <el-table-column
            min-width="150"
            sortable
            label="day"
            property="day"
          ></el-table-column>
          <el-table-column
            min-width="150"
            sortable
            label="energy"
            property="energy"
          ></el-table-column>
         
        </el-table>
      </card>
    </div>
    <div class="col-md-6">
        <card>
          <template slot="header">
            <h5 class="card-category">Meters</h5>
            <h3 class="card-title">Help</h3>
          </template>

          <tabs type="success" vertical class="row">
            <tab-pane label="Location">
              Normally we only have one meter per location, but in case you have to add more location use the form. <br /><br />
              Each location can have multiples meters.
            </tab-pane>

            <tab-pane label="Meter">
              The energy meter is reponsable to measure how much has been consumpted throght it.
              <br /><br />
              Make sure to selected the right location to each meter.
            </tab-pane>

            <tab-pane label="Automated">
              Automated reading is comming soon... <br /><br />.
            </tab-pane>
          </tabs>
        </card>
      </div>
    <div class="col-md-6">
      <card title="Horizontal Form">
        <h4 slot="header" class="card-title">Add Location</h4>
        <form class="form-horizontal" action="#" method="#" @submit.prevent>
          <div class="row">
            <label class="col-md-3 col-form-label">Location</label>
            <div class="col-md-9">
              <base-input v-model="location" placeholder="Location"> </base-input>
            </div>
          </div>

          <!-- <div class="row">
            <label class="col-md-3 col-form-label">Email</label>
            <div class="col-md-9">
              <base-input placeholder="Email" type="email"> </base-input>
            </div>
          </div>

          <div class="row">
            <label class="col-md-3 col-form-label">Password</label>
            <div class="col-md-9">
              <base-input placeholder="Password" type="password"> </base-input>
            </div>
          </div> -->

        </form>
        <div class="row">
          <div class="col-md-9 offset-md-3 col-12">
            <base-button  @click.native="addlocation()" class="mt-3" native-type="submit" type="success">
              Add Location
            </base-button>
          </div>
        </div>
      </card>
    </div>
    <!-- <div class="col-md-6">
      <card title="Horizontal Form">
        <h4 slot="header" class="card-title">Horizontal Form</h4>
       
         <el-table :data="data" :key="componentKey">
          <el-table-column
            min-width="150"
            sortable
            label="day"
            property="day"
          ></el-table-column>
          <el-table-column
            min-width="150"
            sortable
            label="energy"
            property="energy"
          ></el-table-column>
          </el-table>
      </card>
    </div> -->
    <card >
      <div slot="header"><h4 class="card-title">Locations</h4></div>
     <div class="row">
     <div class="col-sm-12">
          <el-table :data="tableData">
            <!-- <el-table-column min-width="50" label="#" align="center">
              <div class="photo" slot-scope="{ row }">
                <img :src="row.img" alt="Table image" />
              </div>
            </el-table-column> -->
            <el-table-column min-width="150" prop="name" label="Location">
            </el-table-column>
            <!-- <el-table-column min-width="200" prop="job" label="Job Position">
            </el-table-column>
            <el-table-column
              min-width="150"
              prop="since"
              align="center"
              label="Since"
            >
          
            </el-table-column>  -->
            <el-table-column
              min-width="150"
              prop="timestamp"
              align="center"
              label="Created"
            >
            </el-table-column> 
            <el-table-column
              min-width="150"
              header-align="right"
              align="right"
              label="Actions"
            >
              <div
                slot-scope="{ row, $index }"
                class="text-right table-actions"
              >
                <el-tooltip
                  content="Refresh"
                  effect="light"
                  :open-delay="300"
                  placement="top"
                >
                  <base-button
                    :type="$index > 2 ? 'success' : 'neutral'"
                    icon
                    size="sm"
                    class="btn-link"
                  >
                    <i class="tim-icons icon-refresh-01"></i>
                  </base-button>
                </el-tooltip>
                <el-tooltip
                  content="Delete"
                  effect="light"
                  :open-delay="300"
                  placement="top"
                >
                  <base-button
                    :type="row.id > 2 ? 'danger' : 'neutral'"
                    icon
                    size="sm"
                    class="btn-link"
                    @click.native="showSwal('delete',row.id)"
                  >
                    <i class="tim-icons icon-simple-remove"></i>
                  </base-button>
                </el-tooltip>
              </div>
            </el-table-column>
          </el-table>
        </div>
</div>
 
    </card>
    <!-- <div class="col-md-12">
      <card class="card-plain" body-classes="table-full-width">
        <template slot="header">
          <h4 class="card-title">Table on Plain Background</h4>
          <p class="category">Here is a subtitle for this table</p>
        </template>
        <el-table
          header-cell-class-name="table-transparent"
          header-row-class-name="table-transparent"
          row-class-name="table-transparent"
          :data="tableData"
        >
          <el-table-column
            min-width="150"
            sortable
            label="Name"
            property="name"
          ></el-table-column>
          <el-table-column
            min-width="150"
            sortable
            label="Country"
            property="country"
          ></el-table-column>
          <el-table-column
            min-width="150"
            sortable
            label="City"
            property="city"
          ></el-table-column>
          <el-table-column
            min-width="150"
            sortable
            align="right"
            header-align="right"
            label="Salary"
            property="salary"
          ></el-table-column>
        </el-table>
      </card>
    </div> -->

    <!-- <div class="col-md-12">
      <card body-classes="table-full-width">
        <h4 slot="header" class="card-title">Regular Table with Colors</h4>
        <el-table :row-class-name="tableRowClassName" :data="tableData">
          <el-table-column
            min-width="150"
            sortable
            label="Name"
            property="name"
          ></el-table-column>
          <el-table-column
            min-width="150"
            sortable
            label="Country"
            property="country"
          ></el-table-column>
          <el-table-column
            min-width="150"
            sortable
            label="City"
            property="city"
          ></el-table-column>
          <el-table-column
            min-width="150"
            sortable
            align="right"
            header-align="right"
            label="Salary"
            property="salary"
          ></el-table-column>
        </el-table>
      </card>
    </div> -->
  </div>
</template>
<script>
import { Table, TableColumn } from 'element-ui';
import { TabPane, Tabs, Collapse, CollapseItem } from 'src/components';
import firebase from '../../Firebase';
import moment from 'moment';
import swal from 'sweetalert2';

export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    TabPane,
    Tabs,
  },
  data() {
    return {
      uid:"",
       componentKey: 0,
      id:0,
        location:"",
     energyf:{},
     energy:{},
     day:{},
      data: [
      {day:0,energy:0},
      {day:1,energy:0},
      {day:2,energy:0},
      {day:3,energy:0},
      {day:4,energy:0},
      {day:5,energy:0},
      {day:6,energy:0}    
      ],
       tableData: []
    };
  },
 async created() {

     const currentUser = firebase.auth().currentUser
  this.uid = currentUser.uid;
//console.log(currentUser.uid)


        firebase.database()
    .ref('location').child(currentUser.uid)
    //.ref('manual').child("test")
    .orderByChild('timestamp').on("value", notes => {
      this.tableData= [];
      notes.forEach(note => {


  
  this.tableData.push({

    id:note.ref.key,
name:note.child("loc").val(),
timestamp:this.timeConverter(note.child("timestamp").val())
  })

      });

    });
  //  let result = await firebase.database()
  //   .ref('location').child("me")
  //   //.ref('manual').child("test")
  //   .orderByChild('timestamp').once("value");

  //   result.forEach(note => {
  //     console.log("date:"+note.child("timestamp").val()+"//"+note.child("loc").val());

  //   });

    var currentTime = new Date();
    var dayweek = currentTime.getDay();
   //console.log(dayweek);
   //console.log(moment().subtract(dayweek,'days').startOf('day').unix())
    firebase.database()
    //.ref('smeter').child("shellyem-B9E9D9").child("0_total")
    .ref('manual').child("newmeter")
    .orderByChild('timestamp').startAt(moment().subtract(dayweek,'days')
    .startOf('day').unix()* 1000-300000).once("value", notes => {
      notes.forEach(note => {
        

        var Time = new Date(note.child("timestamp").val());

//console.log("date"+Time.getDay()+"//"+note.child("0_total").val());
if(Time.getDay()===this.day){
        this.energyf =note.child("0_total").val();
      let subtotal= this.energyf-this.energy;
      let subtotla1=  this.data[Time.getDay()].energy;
let total = subtotal+subtotla1;

        this.data[Time.getDay()]= {
            day:Time.getDay(),
            energy:total
            };
this.energy = note.child("0_total").val();

      }else{

          if (this.id!==0){

this.data[Time.getDay()]= 
            {day:Time.getDay(),
            energy:note.child("0_total").val()-this.energy
            };
this.energy = note.child("0_total").val();


          }
          else{
this.energy = note.child("0_total").val();

          }
          this.id++;
          this.day=Time.getDay();         
        }

      });
      this.forceRerender();
// console.log("----");
// console.log(this.data.length);

// this.data.forEach(ener => {

// //console.log(ener);
 

// });


    });

   },
  methods: {
     showSwal(type,id) {

if (type === 'delete') {
        swal.fire({
          title: 'Are you sure?',
          text: 'You will not be able to recover this location/meters!',
          icon: 'warning',
          showCancelButton: true,
           buttons: true,
  dangerMode: true,
          confirmButtonText: 'Yes, delete it!',
          cancelButtonText: 'No, keep it',
          customClass: {
            confirmButton: 'btn btn-success btn-fill',
            cancelButton: 'btn btn-danger btn-fill'
          },
          buttonsStyling: false
        }).then(
          (willDelete) => 
          {
         //   console.log(id);
            
          
            if(willDelete.value){

               firebase.database()
    .ref('location').child( this.uid).child(id).remove();
swal.fire({
              title: 'Deleted!',
              text: 'Your location file has been deleted.',
              icon: 'success',
              customClass: {
                confirmButton: 'btn btn-success btn-fill'
              },
              buttonsStyling: false
            });
            }else{
                      swal.fire({
                title: 'Cancelled',
                text: 'Your location file is safe :)',
                icon: 'error',
                customClass: {
                  confirmButton: 'btn btn-info btn-fill'
                },
                buttonsStyling: false
              });
            }
          //   dismiss => {
          //   // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
          //   if (dismiss === 'close') {
          //     swal.fire({
          //       title: 'Cancelled',
          //       text: 'Your imaginary file is safe :)',
          //       icon: 'error',
          //       customClass: {
          //         confirmButton: 'btn btn-info btn-fill'
          //       },
          //       buttonsStyling: false
          //     });
          //   }
          // },
            
          }
        );
      }


     },

    addlocation() {
      console.log(this.location);

      firebase.database().ref("location").child(this.uid).push({
        loc: this.location,
        timestamp:moment().unix()*1000
      });
      this.location="";
    },
    timeConverter(UNIX_timestamp){
  var a = new Date(UNIX_timestamp);
  var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  var year = a.getFullYear();
  var month = months[a.getMonth()];
  var date = a.getDate();
  var hour = a.getHours();
  var min = a.getMinutes();
  var sec = a.getSeconds();
  var time = date + ' ' + month + ' ' + year + ' ' + hour + ':' + min + ':' + sec ;
  return time;
},
    forceRerender() {
      console.log(" render ");
      this.componentKey += 1;
    },
    tableRowClassName({ rowIndex }) {
      if (rowIndex === 0) {
        return 'table-success';
      } else if (rowIndex === 2) {
        return 'table-info';
      } else if (rowIndex === 4) {
        return 'table-danger';
      } else if (rowIndex === 6) {
        return 'table-warning';
      }
      return '';
    }
  }
};
</script>
<style>
.table-transparent {
  background-color: transparent !important;
}
</style>
